export default "__VITE_ASSET__DZXPOlMK__"